import { forwardRef } from 'react';

import { isBoolean } from 'lodash';

import { CalendarSmallIcon } from '@setup/svg-icons/svg-icons';
import { formatDateForView } from '@shared/utils/formatDateForView';
import { MuiBaseTextFiled } from 'shared/ui-kit';

type DatePickerInputVariantProps = {
  isDisabled?: boolean;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isFullWidth?: boolean;
  isError?: boolean;
  label?: string;
  placeholder?: string;
  value?: any;
  onChange?: () => void;
  isShowPopup?: boolean;
  errorMessage?: string;
  helperText?: string;
  size?: 'small' | 'medium';
  isClearable?: boolean;
  dateFormat: string;
  [x: string]: any;
};

const DatePickerInputVariant = forwardRef<HTMLHeadingElement, DatePickerInputVariantProps>((props, ref) => {
  const {
    isDisabled,
    isError,
    isFullWidth = true,
    isRequired,
    isReadOnly,
    onChange,
    label,
    placeholder,
    helperText,
    errorMessage,
    value,
    size,
    isShowPopup,
    isClearable,
    dateFormat,
    ...args
  } = props;

  const formattedValue = !!value?.[0]
    ? `${formatDateForView(value[0], dateFormat || 'MMM DD YYYY')} - ${formatDateForView(
        value?.[1],
        dateFormat || 'MMM DD YYYY',
      )}`
    : '';

  return (
    <MuiBaseTextFiled
      {...args}
      variant="outlined"
      label={label}
      ref={ref}
      value={formattedValue}
      isFullWidth={isFullWidth}
      defaultValue={undefined}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isRequired={isRequired}
      isError={isError}
      errorMessage={errorMessage}
      isReadOnly={isReadOnly}
      placeholder={placeholder}
      onChange={onChange}
      helperText={helperText}
      size={size}
      focused={isBoolean(isShowPopup) ? isShowPopup : undefined}
      inputProps={{
        readOnly: true,
        startAdornment: <CalendarSmallIcon />,
      }}
    />
  );
});

export default DatePickerInputVariant;
